// import
import Dashboard from "views/Dashboard/Dashboard";
import Logout from "views/Auth/Logout/Logout.js";

import {CreditIcon, DocumentIcon, HomeIcon, ProfileIcon, RocketIcon, StatsIcon,} from "components/Icons/Icons";
import Roster from "./views/Dashboard/Roster";
import Setting from "./views/Dashboard/Setting/Setting";
import VirtualAnnouncement from "./views/Dashboard/VirtualAnnouncement/VirtualAnnouncement";
import SignIn from "./views/Auth/SignIn";
import SignUp from "./views/Auth/SignUp";
import SchoolSetup from "./views/Dashboard/SchoolSetup/SchoolSetup";
import UserSetup from "./views/Dashboard/UserSetup/UserSetup";
import {GiSchoolBag} from "react-icons/gi";
import {AiFillNotification, AiOutlineNotification} from "react-icons/ai";
import NoticeSetup from "./views/Dashboard/NoticeSetup/NoticeSetup";
import BellSetup from "./views/Dashboard/BellSetup/BellSetup";
import DigitalPTPage from "./pages/DigitalPTPage";
import ActivityLog from "./views/Dashboard/ActivityLog/ActivityLog";
import BellLog from "./views/Dashboard/BellLog/BellLog";
import {FiActivity, FiBell, FiList} from "react-icons/fi";
import {MdFitnessCenter, MdLibraryMusic} from "react-icons/md";
import MusicLibrary from "./views/Dashboard/MusicLibrary/MusicLibrary";
import PhysicalTraining from "./views/Dashboard/PhysicalTraining/PhysicalTraining";
import BellStatusPage from "./views/Dashboard/BellStatus";
import BusinessReport from "./views/Dashboard/BusinessReport";
import Advertisement from "./views/Dashboard/Advertisement/Advertisement";
import Sales from "./views/Dashboard/Sales/Sales";
import {MdCampaign, MdMap, MdPointOfSale} from "react-icons/md";

var dashRoutes = [
    {
        path: "/dashboard",
        name: "Dashboard",
        nepaliName: "ड्यासबोर्ड",
        rtlName: "لوحة القيادة",
        icon: <HomeIcon color="inherit"/>,
        component: Dashboard,
        layout: "/admin",
    },
    {
        path: "/school-setup",
        name: "School Setup",
        nepaliName: "विद्यालय सेटअप",
        icon: <GiSchoolBag color="inherit"/>,
        component: SchoolSetup,
        layout: "/admin",
    },
    {
        path: "/user-setup",
        name: "User Setup",
        nepaliName: "प्रयोगकर्ता सेटअप",
        icon: <ProfileIcon color="inherit"/>,
        component: UserSetup,
        layout: "/admin",
    },
    {
        path: "/bell-setup",
        name: "Bell Setup",
        nepaliName: "घण्टी सेटअप",
        icon: <AiOutlineNotification color="inherit"/>,
        component: BellSetup,
        layout: "/admin",
    },
    {
        path: "/bell-status",
        name: "Bell Status",
        nepaliName: "घण्टी स्थिति",
        icon: <StatsIcon color="inherit"/>,
        component: BellStatusPage,
        layout: "/admin",
    },
    {
        path: "/music-library",
        name: "Music Library",
        nepaliName: "संगीत पुस्तकालय",
        icon: <MdLibraryMusic color="inherit"/>,
        component: MusicLibrary,
        layout: "/admin",
    },
    {
        path: "/physical-training",
        name: "Physical Training",
        nepaliName: "शारीरिक प्रशिक्षण",
        icon: <MdFitnessCenter color="inherit"/>,
        component: PhysicalTraining,
        layout: "/admin",
    },
    {
        path: "/notice",
        name: "Notices",
        nepaliName: "सूचनाहरू",
        icon: <AiFillNotification color="inherit"/>,
        component: NoticeSetup,
        layout: "/admin",
    },
    {
        path: "/advertisement",
        name: "Advertisements",
        nepaliName: "विज्ञापनहरू",
        icon: <MdCampaign color="inherit"/>,
        component: Advertisement,
        layout: "/admin",
    },
    {
        path: "/push-notification",
        name: "Push Notification",
        nepaliName: "पुश सूचना",
        icon: <AiFillNotification color="inherit"/>,
        component: UserSetup,
        layout: "/admin",
    },
    {
        path: "/setting",
        name: "Settings",
        nepaliName: "सेटिङहरू",
        rtlName: "لوحة القيادة",
        icon: <CreditIcon color="inherit"/>,
        component: Setting,
        layout: "/admin",
    },
    // {
    //     path: "/roster",
    //     name: "Roster",
    //     nepaliName: "अवधि सूची",
    //     rtlName: "لوحة القيادة",
    //     icon: <StatsIcon color="inherit"/>,
    //     component: Roster,
    //     layout: "/admin",
    // },
    // {
    //     path: "/virtual-announcement",
    //     name: "Virtual Announcement",
    //     nepaliName: "भर्चुअल घोषणा",
    //     rtlName: "لوحة القيادة",
    //     icon: <StatsIcon color="inherit"/>,
    //     component: VirtualAnnouncement,
    //     layout: "/admin",
    // },
    // {
    //     path: "/digital-pt",
    //     name: "Digital PT",
    //     nepaliName: "डिजिटल पीटी",
    //     icon: <FiActivity color="inherit"/>,
    //     component: DigitalPTPage,
    //     layout: "/admin",
    // },
    {
        path: "/activity-log",
        name: "Activity Log",
        nepaliName: "गतिविधि लग",
        icon: <FiList color="inherit"/>,
        component: ActivityLog,
        layout: "/admin",
    },
    {
        path: "/bell-log",
        name: "Bell Log",
        nepaliName: "घण्टी लग",
        icon: <FiBell color="inherit"/>,
        component: BellLog,
        layout: "/admin",
    },
    {
        path: "/business-report",
        name: "Business Report",
        nepaliName: "व्यापार प्रतिवेदन",
        icon: <MdMap color="inherit"/>,
        component: BusinessReport,
        layout: "/admin",
    },
    {
        path: "/sales",
        name: "Sales",
        nepaliName: "बिक्री",
        icon: <MdPointOfSale color="inherit"/>,
        component: Sales,
        layout: "/admin",
    },
    {
        name: "ACCOUNT",
        nepaliName: "खाता",
        category: "account",
        rtlName: "صفحات",
        state: "pageCollapse",
        views: [
            {
                path: "/logout",
                name: "Sign Out",
                nepaliName: "साइन आउट",
                icon: <RocketIcon color="inherit"/>,
                component: Logout,
                layout: "/auth",
            },
            {
                path: "/signin",
                name: "Sign In",
                nepaliName: "साइन इन",
                rtlName: "لوحة القيادة",
                icon: <DocumentIcon color="inherit"/>,
                component: SignIn,
                layout: "/auth",
            },
            {
                path: "/signup",
                name: "Sign Up",
                nepaliName: "साइन अप",
                icon: <DocumentIcon color="inherit"/>,
                component: SignUp,
                layout: "/auth",
            }
        ],
    },
];
export default dashRoutes;
